export const EShapeActionValueGestureOperationType = wcardinal.ui.EShapeActionValueGestureOperationType;